import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import iBorder from "../../../assets/icons/hero-description/border.png";
import iDuck from "../../../assets/icons/hero-description/duck.png";
import iLineTop from "../../../assets/icons/hero-description/line-top.png";
import iLineTopMobile from "../../../assets/icons/hero-description/line-top-mobile.png";
import iLineBottom from "../../../assets/icons/hero-description/line-bottom.png";
import iLineBottomMobile from "../../../assets/icons/hero-description/line-bottom-mobile.png";
import iWave from "../../../assets/icons/hero-description/wave.svg";
import { useWidth } from "../../../hooks/use-width";
import Button from "../../common/button/button";
import { paths } from "../../../routes/paths";
import { useNavigate } from "react-router-dom";
import "./hero-description.sass";

const words = ["отдыхают", "знакомятся", "живут"];

const HeroDescription = () => {
  const navigate = useNavigate();
  const [changingText, setChangingText] = useState<string>("отдыхают");
  const [animationClass, setAnimationClass] = useState<"enter" | "exit">(
    "enter",
  );
  const { isMobileWidth } = useWidth();
  const changingTextRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const changingTextEl = changingTextRef.current;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    let enterTween: gsap.core.Tween | null = null;
    let exitTween: gsap.core.Tween | null = null;

    const interval = setInterval(() => {
      if (isMobileWidth && changingTextRef.current) {
        exitTween?.kill();
        enterTween?.kill();

        exitTween = gsap.to(changingTextRef.current, {
          yPercent: -100,
          opacity: 0,
          duration: 0.3,
          ease: "power2.inOut",
          onComplete: () => {
            setChangingText((prev) => {
              const currentIndex = words.indexOf(prev);
              const nextIndex = (currentIndex + 1) % words.length;
              return words[nextIndex];
            });

            enterTween = gsap.fromTo(
              changingTextRef.current,
              {
                yPercent: 100,
                opacity: 0,
              },
              {
                yPercent: 0,
                opacity: 1,
                duration: 0.3,
                ease: "power2.inOut",
              },
            );
          },
        });

        return;
      }

      setAnimationClass("exit");

      timeoutId = setTimeout(() => {
        setChangingText((prev) => {
          const currentIndex = words.indexOf(prev);
          const nextIndex = (currentIndex + 1) % words.length;
          return words[nextIndex];
        });

        setAnimationClass("enter");
      }, 300);
    }, 3000);

    return () => {
      clearInterval(interval);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      exitTween?.kill();
      enterTween?.kill();
      if (isMobileWidth && changingTextEl) {
        gsap.set(changingTextEl, { clearProps: "transform,opacity" });
      }
    };
  }, [isMobileWidth]);

  return (
    <div className="hero-description__overlap">
      <div className="hero-description">
      <div className="hero-description__background" />
      <div className="hero-description__text">
        Мы встраиваем бренд{" "}
          {isMobileWidth && <br />}
          в жизни <br /> людей там, где они{" "}
        {isMobileWidth && <br />}{" "}
        <span className="changing-text-container">
          <span
            ref={changingTextRef}
            className={`hero-description__changing changing-text ${isMobileWidth ? "" : animationClass}`}
          >
            {changingText}
          </span>
        </span>
      </div>

      <div className="hero-description__text">
        Не просто событие,
        <br /> не просто акция —
        <br />
        <div className="hero-description__text hero-description__text-special">
          создаём контекст, в{isMobileWidth && <br />} котором
          <br />
          бренд становится{" "}
          {isMobileWidth && <br />}
          естественным
        </div>
      </div>

      <Button
        className="hero-description__button"
        onClick={() => navigate(`/${paths.AboutUsPage}`)}
      >
        Узнайте о нас подробнее
      </Button>

      <img
        src={iBorder}
        className="hero-description__img hero-description__border"
        alt=""
      />
      <img
        src={iDuck}
        className="hero-description__img hero-description__duck"
        alt=""
      />
      {!isMobileWidth && (
        <img
          src={iLineTop}
          className="hero-description__img hero-description__line-top"
          alt=""
        />
      )}
      {!isMobileWidth && (
        <img
          src={iLineBottom}
          className="hero-description__img hero-description__line-bottom"
          alt=""
        />
      )}
      {isMobileWidth && (
        <img
          src={iLineTopMobile}
          className="hero-description__img hero-description__line-top"
          alt=""
        />
      )}
      {isMobileWidth && (
        <img
          src={iLineBottomMobile}
          className="hero-description__img hero-description__line-bottom"
          alt=""
        />
      )}
      <img
        src={iWave}
        className="hero-description__img hero-description__wave"
        alt=""
      />
      </div>
    </div>
  );
};

export default HeroDescription;
